<div class="mod-page" data-module="complaints">
<div class="gsearch" [class.compact]="query().length > 0">
  <div class="gsearch-top">
    <div class="gsearch-mark">
      <span class="mark-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16v16H4z" opacity="0" /><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" /></svg>
      </span>
      <span class="mark-word">Case<b>Search</b></span>
    </div>
    @if (!query()) {
      <p class="gsearch-lede">Find anything across every case you're authorized to see</p>
    }

    <div class="gsearch-box">
      <svg class="gsearch-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" />
      </svg>
      <input
        type="text"
        [ngModel]="query()"
        (ngModelChange)="query.set($event)"
        placeholder="Search by name, village, mobile, subject, summary…"
        autofocus
      />
      @if (query()) {
        <button type="button" class="gsearch-clear" title="Clear" (click)="query.set('')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      }
    </div>
  </div>

  <div class="gsearch-results">
    @if (query() && !ready()) {
      <p class="ghint">Keep typing — at least 2 characters to search.</p>
    } @else if (ready() && !results().length) {
      <p class="ghint">No cases matched “{{ query() }}”.</p>
    } @else if (ready()) {
      <p class="gcount">About {{ results().length }} result{{ results().length === 1 ? '' : 's' }}</p>
      @for (item of results(); track item.id) {
        <a class="gresult" [routerLink]="['/complaints', item.id]" [queryParams]="{ highlight: query().trim() }">
          <div class="gresult-meta">
            <span>#{{ item.trackingId || item.id }}</span>
            <span class="gdot" aria-hidden="true">›</span>
            <span>{{ item.department || '—' }}</span>
            <span [class]="'pill status-' + statusTone(item.status)" [attr.title]="item.status">{{ item.status }}</span>
          </div>
          <div class="gresult-title">
            @for (seg of titleSegments(item); track $index) {
              <span [class.hit]="seg.hit">{{ seg.text }}</span>
            }
          </div>
          <div class="gresult-byline">{{ item.complainantName || item.citizenName || '—' }} · {{ fmtDate(item.submittedAt) }}</div>
          @if (snippetFor(item); as snip) {
            <div class="gresult-snippet">
              <span class="gresult-field-label">{{ snip.label }}:</span>
              @for (seg of snip.segments; track $index) {
                <span [class.hit]="seg.hit">{{ seg.text }}</span>
              }
            </div>
          }
        </a>
      }
    }
  </div>
</div>
</div>
